import { render, staticRenderFns } from "./DialogSelectCita.vue?vue&type=template&id=f2148150&"
import script from "./DialogSelectCita.vue?vue&type=script&lang=js&"
export * from "./DialogSelectCita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports